var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crewHome"},[_c('iframe',{ref:"iframeRef",attrs:{"src":_vm.ismSrc,"width":"100%","height":"100%","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }